import { LABELS } from '@/config/currencies';

/**
 * Money formatting.
 *
 * @see {@link https://developer.mozilla.org/ru/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat}
 *
 * @param  {Number|string} amount
 * @param  {string} currency
 * @param  {number} fractionDigits
 * @param  {boolean} floor
 * @param  {options} [options]
 * @return {string}
 */
export default (amount, currency, { fractionDigits = 2, floor = true, ...options } = {}) => {
  if (!currency) {
    return amount;
  }

  if (!fractionDigits && floor) {
    amount = (amount >= 0 ? 1 : -1) * Math.floor(Math.abs(amount));
  }

  currency = currency.toUpperCase();

  const isCAD = currency === 'CAD';
  const isAED = currency === 'AED';
  const isSAR = currency === 'SAR';
  const isDKK = currency === 'DKK';

  const formatOptions = {
    style: 'currency',
    currency,
    currencyDisplay: isCAD || isDKK ? 'code' : 'symbol',
    maximumFractionDigits: fractionDigits,
    minimumFractionDigits: fractionDigits,
    ...options,
  };

  const isRtl = isAED || isCAD || isSAR || isDKK;

  // reverse currency for RTL
  const locales = isRtl ? 'fr-FR' : 'en-US';

  amount = new Intl.NumberFormat(locales, formatOptions).format(amount);

  if (isRtl) {
    amount = amount.replace(',', '.');

    return isDKK ? amount.replace(currency, LABELS.dkk) : amount;
  }

  return amount.replace(',', ' ');
};
